<!--
 * @Author: xing.huang
 * @Date: 2021-10-26 11:22:09
 * @LastEditTime: 2023-02-16 16:16:50
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\alarm\ExceptionConfig\index.vue
 * 
-->
<template>
  <div class="exception-config">
    <!-- <div>配置列表</div> -->
    <el-card class="table-card">
      <el-row style="margin-bottom:10px">
        <el-col style="text-align:right">
          <i class="el-icon-my-help" type="primary" size="small" @click="showHelp()"></i>
        </el-col>
      </el-row>
      <div>
        <el-row>
          <div class="grid-content">
            <el-table :data="eventList" style="width: 100%;height:100%">
              <el-table-column label="事件名称" prop="anomalyName" min-width="200"></el-table-column>
              <el-table-column prop="isEnable" label="状态" min-width="200">
                <template slot-scope="scope">
                  <span :style="{ color: scope.row.isEnable == 0 ? '#F55C53' : '#55CB38' }">{{ parseIsEnable(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-switch
                    v-if="permission.btn_anomalyResponse_edit"
                    @change="changeStatus($event, scope.row)"
                    v-model="scope.row.isEnable"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#13ce66"
                  ></el-switch>
                  <el-button v-if="permission.btn_anomalyResponse_switchEnable" @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-row>
      </div>
    </el-card>
    <el-dialog title="帮助" :visible.sync="showHelpDialog" width="1000px" center :lock-scroll="false" :close-on-click-modal="false" @close="showHelpDialog = false">
      <div style="text-align: center;margin-top:20px">
        <el-table :data="helpList" border tooltip-effect="dark">
          <el-table-column label="事件名称" prop="type" min-width="150"></el-table-column>
          <el-table-column label="事件说明" prop="content" min-width="200"></el-table-column>
          <el-table-column label="触发条件" prop="info" min-width="220"></el-table-column>
        </el-table>
        <el-button @click="showHelpDialog = false" style="margin-top:10px">取 消</el-button>
      </div>
    </el-dialog>
    <edit :anomalyCode="selectAnomalyCode" :isShow="showEdit" :anomalyName="selectAnomalyName" :id="selectId"></edit>
  </div>
</template>
<script>
import Edit from "./exceptionConfigEdit";
export default {
  components: {
    Edit
  },
  data() {
    return {
      showHelpDialog: false,
      helpList: [
        // {type:'设备异常-手动',	content:'设备故障信息',	info:'手动上报设备故障信息'},
        // {type:'缺料异常',	content:'生产过程中缺料',	info:'手动上报缺料信息',},
        // {type:'工艺异常',	content:'设备生产工艺异常',	info:'定义参数告警范围逻辑，结合数据采集，实现异常判断',},
        { type: "工序逾期开工", content: "未按照工序计划时间开始生产", info: "工序计划开始时间" },
        { type: "工单逾期开工", content: "未按照工单计划时间开始生产", info: "工单计划开始时间" },
        { type: "工序完工逾期", content: "未按照工序计划时间完成生产", info: "工序计划完工时间" },
        { type: "工单完工逾期", content: "未按照工单计划时间完成生产", info: "工单计划完工时间" },
        // {type:'设备异常-自动',	content:'设备故障信息',	info:'定义设备故障代码信息，结合数据采集，实现异常判断',},
        { type: "在制品呆滞", content: "工序在制品滞留时间超过规定时长", info: "（状态为生产中的工单）首道工序不做判断；非首道工序呆滞时长=当前时间-最后报工时间，且上工序报工数-当前工序报工数>0" },
        { type: "在制品积压", content: "工序在制品数量超过规定要求", info: "（状态为生产中的工单）首道工序不做判断；非首道工序在制品数量=前工序累计报工数-后工序累计报工数" },
        { type: "母卷质量检超时", content: "母卷质量检操作过程超过规定时长", info: "母卷质量检单生成时间+规定时长，未完成母卷质量检单" },
        { type: "子卷质量检超时", content: "子卷质量检操作过程超过规定时长", info: " 子卷质量检单生成时间+规定时长，未完成子卷质量检单" },
        { type: "自检超时", content: "自检操作过程超过规定时长", info: "自检单生成时间+规定时长，未完成自检单" },
        { type: "点检超时", content: "在指定时间内未进行点检。该异常逻辑只对每日点检的点检单生效", info: "点检单在设定时间内，未完成点检" },
        { type: "其他异常", content: "员工上报异常信息", info: "手动上报" }
      ],
      selectAnomalyCode: "",
      selectAnomalyName: "",
      selectId: null,
      showEdit: false,
      selectName: "",
      eventList: [
        //1-设备异常-手动、2-缺料异常、3-工艺异常、4-工序逾期开工、5-工单逾期开工、6-工序完工逾期、7-工单完工逾期、
        //8-设备异常-自动、9-在制品呆滞、10-在制品积压、11-母卷质量检超时、12-子卷质量检超时、13-自检超时
        { name: "设备异常-手动", type: 1, isEnable: 1 },
        { name: "缺料异常", type: 2, isEnable: 1 },
        { name: "工艺异常", type: 3, isEnable: 0 },
        { name: "工序逾期开工", type: 4, isEnable: 0 },
        { name: "工单逾期开工", type: 5, isEnable: 0 },
        { name: "工序完工逾期", type: 6, isEnable: 0 },
        { name: "工单完工逾期", type: 7, isEnable: 0 },
        { name: "设备异常-自动", type: 8, isEnable: 0 },
        { name: "在制品呆滞", type: 9, isEnable: 0 },
        { name: "在制品积压", type: 10, isEnable: 0 },
        { name: "母卷质量检超时", type: 11, isEnable: 0 },
        { name: "子卷质量检超时", type: 12, isEnable: 0 },
        { name: "自检超时", type: 13, isEnable: 0 }
      ],
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    showHelp() {
      this.showHelpDialog = true;
    },
    handleEdit(row) {
      this.selectAnomalyCode = row.anomalyCode;
      this.selectId = row.id;
      this.showEdit = true;
      this.selectAnomalyName = row.anomalyName;
    },
    changeStatus(ev, row) {
      this.$RequestUtil.get({
        url: "/api/anomalyResponse/switchEnable",
        type: "sync",
        params: { id: row.id },
        success: res => {
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.init();
          } else {
            row.isEnable = !row.isEnable;
            console.log(res.message);
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },
    init() {
      this.$RequestUtil.get({
        url: "/api/anomalyResponse/list",
        type: "sync",
        params: {},
        success: res => {
          this.eventList = res.data;
          this.eventList.forEach(item => {
            item.isEnable = Number(item.isEnable);
          });
          console.table(this.eventList);
        }
      });
    },
    parseIsEnable(row) {
      if (row.isEnable == 1) {
        return "启用";
      } else {
        return "禁用";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/alarm/ExceptionConfig/index.vue